<template></template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    const pathName = window.location.pathname.substring(1);
    if (pathName && pathName !== "") {
      if (pathName.substring(0, 1).toUpperCase() === "D") {
        const id = pathName.substring(1).split("-")[0];
        this.$router.push({
          name: "albumviewPhotostream",
          query: {
            id,
          },
        });
      } else if (pathName.substring(0, 1).toUpperCase() === "V") {
        const Coid = pathName.substring(1).split("-")[0];
        const Liid = pathName.substring(1).split("-")[1];
        this.$router.push({
          name: "photoview",
          query: {
            Coid,
            Liid,
          },
        });
      } else if (pathName.substring(0, 1).toUpperCase() === "A") {
        const userId = pathName.substring(1).split("-")[0];
        this.$router.push({
          name: "customerPublishLook",
          query: {
            authorId: userId,
          },
        });
      } else if (pathName.substring(0, 1).toUpperCase() === "E") {
        const id = pathName.substring(1).split("-")[0];
        this.$router.push({
          name: "blogDetail",
          query: {
            id: id.replace("E", ""),
          },
        });
      }
    }
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/common/sortLink.vue